import { Alignment, Displaying, Spacing } from "@bonusx-global/bx-design-system";

import { DislikeOutlined, DislikeSolid, LikeOutlined, LikeSolid } from "@bonusx-global/bx-icons";
import Box from "@mui/material/Box";
import { FeedbackEnum } from "../../../../../enums/feedback.enum";
import { FeedbackButton } from "./components/feedback-button/feedback-button";

interface AiResponseFeedbackButtonsProps {
  onLike: () => void;
  onDislike: () => void;
  feedback: FeedbackEnum | null;
}

export const THUMBS_UP_BUTTON_ID = "ai-response-feedback-thumbs-up-button";
export const THUMBS_DOWN_BUTTON_ID = "ai-response-feedback-thumbs-down-button";

export function AiResponseFeedbackButtons({
  onLike,
  onDislike,
  feedback,
}: Readonly<AiResponseFeedbackButtonsProps>): JSX.Element {
  const shouldShowThumbsUp = feedback !== FeedbackEnum.NEGATIVE;
  const shouldShowThumbsDown = feedback !== FeedbackEnum.POSITIVE;

  return (
    <Box display={Displaying.flex} alignContent={Alignment.flexEnd} gap={Spacing[750]}>
      {shouldShowThumbsUp && (
        <FeedbackButton
          id={THUMBS_UP_BUTTON_ID}
          onClick={onLike}
          feedback={feedback}
          targetFeedback={FeedbackEnum.POSITIVE}
          solidIcon={<LikeSolid />}
          outlinedIcon={<LikeOutlined />}
        />
      )}
      {shouldShowThumbsDown && (
        <FeedbackButton
          id={THUMBS_DOWN_BUTTON_ID}
          onClick={onDislike}
          feedback={feedback}
          targetFeedback={FeedbackEnum.NEGATIVE}
          solidIcon={<DislikeSolid />}
          outlinedIcon={<DislikeOutlined />}
        />
      )}
    </Box>
  );
}
